import React from 'react';

/**
 * Helper to wrap React.lazy imports with retry logic.
 * Handles ChunkLoadError (e.g. timeout, dev server restarts, or new production deployments)
 * by attempting a transparent page reload once to pull the fresh bundle manifest.
 */
export function lazyWithRetry<T extends React.ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> {
  return React.lazy(async () => {
    const pageHasAlreadyBeenReloaded = JSON.parse(
      window.sessionStorage.getItem('retry-lazy-refreshed') || 'false'
    );
    try {
      const component = await componentImport();
      window.sessionStorage.setItem('retry-lazy-refreshed', 'false');
      return component;
    } catch (error: any) {
      if (!pageHasAlreadyBeenReloaded) {
        window.sessionStorage.setItem('retry-lazy-refreshed', 'true');
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
